import React, { useState, useEffect, useRef } from 'react';
import { Terminal, RefreshCw } from 'lucide-react';
import styles from './LogsPage.module.css';

// Simula log in tempo reale via polling (sostituire con WebSocket in v2)
const MOCK_LOGS = [
  { id: 1,  level: 'INFO',    msg: 'JARVIS agent avviato',               ts: '08:30:01', src: 'core' },
  { id: 2,  level: 'INFO',    msg: 'Connesso a Ollama: llama3.1',         ts: '08:30:02', src: 'llm' },
  { id: 3,  level: 'INFO',    msg: 'ChromaDB connesso',                   ts: '08:30:03', src: 'memory' },
  { id: 4,  level: 'INFO',    msg: 'Redis connesso',                      ts: '08:30:03', src: 'cache' },
  { id: 5,  level: 'SUCCESS', msg: 'Celery worker pronto (3 task queue)', ts: '08:30:05', src: 'worker' },
  { id: 6,  level: 'INFO',    msg: 'Briefing mattutino inviato',          ts: '08:30:30', src: 'proactive' },
  { id: 7,  level: 'INFO',    msg: 'Chat: utente connesso via WebSocket', ts: '09:12:44', src: 'chat' },
  { id: 8,  level: 'INFO',    msg: 'Agent: intent → CRM',                ts: '09:12:48', src: 'agent' },
  { id: 9,  level: 'SUCCESS', msg: 'CRM: attività creata #1045',         ts: '09:12:51', src: 'crm' },
  { id: 10, level: 'INFO',    msg: 'Follow-up checker: 2 attività in scadenza', ts: '10:00:00', src: 'proactive' },
  { id: 11, level: 'WARN',    msg: 'Pipedrive rate limit: rallentamento', ts: '10:00:01', src: 'crm' },
  { id: 12, level: 'INFO',    msg: 'STT: trascrizione completata (1.2s)', ts: '10:15:33', src: 'voice' },
  { id: 13, level: 'INFO',    msg: 'TTS: audio sintetizzato (0.8s)',      ts: '10:15:35', src: 'voice' },
];

const LEVEL_COLOR = { INFO: 'accent', SUCCESS: 'green', WARN: 'amber', ERROR: 'red' };

export default function LogsPage() {
  const [logs, setLogs] = useState(MOCK_LOGS);
  const [filter, setFilter] = useState('ALL');
  const [autoScroll, setAutoScroll] = useState(true);
  const bottomRef = useRef(null);

  useEffect(() => {
    if (autoScroll) bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [logs, autoScroll]);

  const filtered = filter === 'ALL' ? logs : logs.filter(l => l.level === filter);

  return (
    <div className={styles.page}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <Terminal size={15} className="text-accent" />
          <span className={styles.title}>Action Log</span>
          <span className={styles.count}>{logs.length} eventi</span>
        </div>
        <div className={styles.controls}>
          {['ALL','INFO','SUCCESS','WARN','ERROR'].map(f => (
            <button
              key={f}
              className={`${styles.filterBtn} ${filter === f ? styles.filterActive : ''}`}
              onClick={() => setFilter(f)}
            >
              {f}
            </button>
          ))}
          <button className={styles.iconBtn} onClick={() => setAutoScroll(p => !p)}>
            <RefreshCw size={13} className={autoScroll ? 'text-accent' : 'text-3'} />
          </button>
        </div>
      </div>

      <div className={styles.terminal}>
        {filtered.map(log => (
          <div key={log.id} className={styles.line}>
            <span className={styles.ts}>{log.ts}</span>
            <span className={`${styles.level} ${styles['level_' + LEVEL_COLOR[log.level]]}`}>
              {log.level.padEnd(7)}
            </span>
            <span className={styles.src}>[{log.src}]</span>
            <span className={styles.msg}>{log.msg}</span>
          </div>
        ))}
        <div ref={bottomRef} />
      </div>
    </div>
  );
}
